import { useTranslation } from "react-i18next";
import ExploreOtherOptions from "../../components/ExploreOtherOptions";
import { BookingBox } from "../../components/booking-card/BookingBox";
import UiSection from "../../components/box/UiSection";
import Tabs from "../../components/detail/Tabs";
import { ProdAttrPicker } from "../../components/prodattr-picker/ProdAttrPicker";
import { ProductBanner } from "../../components/product-detail/ProductBanner";
import { ProductInformation } from "../../components/product-detail/ProductInformation";
import { ProductMoreInfo } from "../../components/product-detail/ProductMoreInfo";
import { useUiVersion } from "../../hooks/useUiVersion";
import { ProdAttrUtils } from "../../utils/productAttributeUtils";
import BookingCardBottom from "../booking-card/BookingCardBottom";
import ProductInfoHeader from "./ProductInfoHeader";
import { useProductDetailPage } from "./useProductDetailPage";

export const ProductDetailPage = () => {
  const { uiVersion } = useUiVersion();
  return <ProductDetailPageContent key={uiVersion} />;
};
export const ProductDetailPageContent = () => {
  const { t } = useTranslation();
  const { productData, isLoading, isError } = useProductDetailPage();
  if (isLoading) {
    return null;
  }
  if (isError) {
    return <div>Error fetching data</div>;
  }

  const tabs = [
    t("Information2"),
    t("Select Option"),
    productData?.scheduleImg ? t("Schedule") : "",
    !!ProdAttrUtils.TOUR.extractHighlight(productData?.attributeList).length
      ? t("Highlights")
      : "",
    productData?.locationInstruction ? t("Location Instruction") : "",
    productData?.operatingInfo ? t("Operating Info") : "",
    productData?.howToUse ? t("How to Use") : "",
    productData?.noteContent ? t("Notes") : "",
  ].filter((tab) => tab);

  return (
    <div className="relative">
      {/* <BreadcrumbNavigation ls={["Ticket", productData?.cityName]} /> */}
      <ProductBanner d={productData} />
      <div className="ui-container relative mt-[3.1044rem]">
        <ProductInfoHeader d={productData} />
        <div className="flex gap-[2rem]">
          <div className="pd-left">
            <Tabs tabs={tabs} />
            <ProductInformation d={productData} />
            <UiSection title={t("Select Option")} className="pb-0" />
            <ProdAttrPicker d={productData} mode="FORM" />
            <ProductMoreInfo d={productData} />
          </div>
          <BookingBox />
        </div>
        {productData && (
          <ExploreOtherOptions
            id={productData.id}
            productType={productData.productType}
          />
        )}
      </div>
      <BookingCardBottom />
    </div>
  );
};
